import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { resetPasswordReset } from '../../redux/authentication/actions';
import { getOnboardingRedirectPath, MERCHANT_ONBOARDING_FIRST_PATH } from '../../utils/onboardingRedirect';

/**
 * After password reset, the saga logs the user in without assigning window.location.
 * The app switches to the logged-in route tree while the URL can still be /reset-password.
 * This performs SPA navigation to the same targets the saga previously used (onboarding or home).
 */
export default function PostResetPasswordNavigate() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const isLoggedIn = useSelector((state) => state?.auth?.login);
  const resetPasswordSuccess = useSelector((state) => state?.auth?.resetPasswordSuccess);
  const user = useSelector((state) => state?.auth?.user);

  useEffect(() => {
    if (!isLoggedIn || !resetPasswordSuccess) return;
    if (!location.pathname.includes('reset-password')) return;

    const onboardingSteps = user?.onboarding_steps ?? null;
    if (onboardingSteps && onboardingSteps.all_completed === false) {
      const path = getOnboardingRedirectPath(onboardingSteps);
      navigate(path || MERCHANT_ONBOARDING_FIRST_PATH, { replace: true });
    } else {
      navigate('/', { replace: true });
    }
    dispatch(resetPasswordReset());
  }, [isLoggedIn, resetPasswordSuccess, location.pathname, user, navigate, dispatch]);

  return null;
}
